import { merge, Observable, of } from 'rxjs';
import { map, shareReplay, skipWhile } from 'rxjs/operators';

export interface WorkStates<RESULT> {
  readonly isLoading$: Observable<boolean>;
  readonly isSuccess$: Observable<boolean>;
  readonly successEvents$: Observable<boolean>;
  readonly workResults$: Observable<RESULT>;
}

export function isFailed$(stateMap: WorkStates<any>): Observable<boolean> {
  return stateMap.isSuccess$.pipe(map((success) => !success));
}

export function startWorkWith<T>(state: WorkStates<T>, value: T): WorkStates<T> {
  return {
    isLoading$: state.isLoading$,
    isSuccess$: state.isSuccess$,
    successEvents$: state.successEvents$,
    workResults$: merge(state.workResults$.pipe(skipWhile((v) => v === value)), of(value)).pipe(
      skipWhile((v) => v !== value),
      shareReplay(1),
    ),
  };
}
